import { useState, useEffect } from 'react';
import authService from '../../../../services/auth.service';

// ============================================================================
// Custom Hooks - MyInvoices Specific Logic
// ============================================================================

/**
 * useCompanySellerData - Fetches and manages company/seller data from auth service
 * Auto-selects default seller or first available seller on mount
 * @returns {Object} { selectedSeller, loading, error }
 */
export const useCompanySellerData = () => {
    const [selectedSeller, setSelectedSeller] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    // Fetch company and seller data on mount
    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);
                const response = await authService.getCompanySellerService();

                if (response?.data?.Status === 200 && response?.data?.Entity) {
                    const sellers = response.data.Entity;

                    // Auto-select default seller or first seller
                    const defaultSeller = sellers.find(s => s.isDefault) || sellers[0];
                    setSelectedSeller(defaultSeller || null);
                } else {
                    setError('Failed to load seller data');
                }
            } catch (err) {
                console.error('Error fetching company seller data:', err);
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    return { selectedSeller, loading, error };
};
